import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonService} from '../../common.service';

@Component({
  selector: 'questionnaire-textarea',
  templateUrl: './questionnaire-textarea.component.html',
  styleUrls: ['./questionnaire-textarea.component.css']
})

export class QuestionnaireTextareaComponent implements OnInit, AfterViewInit, OnChanges{
  @Input() selectedTag: any; //选择的标签
  @Input() placeholder: any; //placeholder

  @Output() outPutTextareaContext = new EventEmitter<any>(); //回传textarea的value

  isShowPlaceholder: boolean = true; //是否显示placeholder
  textarea: any; //富文本对象

  constructor(
    private el: ElementRef,
    private commonService: CommonService,
  ) {
  }


  ngOnInit() {
    this.textarea = this.el.nativeElement.querySelector('textarea');
  }


  ngAfterViewInit(){

  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.selectedTag){
      this.showSelectedTag();
    }
  }


  //展示选择的标签
  showSelectedTag(){
    let target = this.el.nativeElement.querySelector('textarea');
    target.value = this.selectedTag;
    this.outPutTextareaContext.emit(target.value);
  }


  //隐藏Placeholder
  closePlaceholder(){
    this.isShowPlaceholder = false;
    this.textarea.focus();
  }

  //textarea获取焦点事件
  textareaFocus(){
    this.isShowPlaceholder = false;
  }

  //textarea失去焦点触发事件
  textareaBlur(){
    this.commonService.initPage();
    this.isShowPlaceholder = this.textarea.value === "";
    this.outPutTextareaContext.emit(this.textarea.value);
  }



}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-textarea/questionnaire-textarea.component.ts